import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <img src={logo} alt="Ron Johanson logo" />
          <span>Ron Johanson for Chemung County Legislature &middot; 2nd District</span>
        </div>
        <div className="footer__legal">
          &copy; {year} Friends of Ron Johanson. Paid for by the Committee to
          Elect Ron Johanson.
          <div className="footer__links">
            <Link to="/privacy">Privacy Policy</Link>
            <span aria-hidden="true">&middot;</span>
            <Link to="/terms">Terms of Service</Link>
            <span aria-hidden="true">&middot;</span>
            <a
              href="https://www.linkedin.com/in/ronald-johanson-3ab62a10/"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>
          </div>
          <div className="footer__watermark">
            Made by{' '}
            <a
              href="https://shawnymedia.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              ShawnyMedia
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
